module.exports = __webpack_public_path__ + "img/profile-bg.ddc2bf71.jpg";